import { TitleCasePipe } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  NgbInputDatepicker,
  NgbTooltip,
  NgbTypeahead,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, of, BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import {
  EnterpriseSearchService,
  RailSearchJourneyType,
  ReferenceRailCardQualifier,
  ServiceType,
  UserService,
  User,
  UserLoyaltyCode
} from '@sabstravtech/obtservices/angular';
import {
  type RailEnterpriseSearchInterface,
  type Traveller,
  type LocationDetails,
  type AllowedRailClass,
  ServiceProvider,
  TrainlineTraveller,
  TrainlineSearchConfigTypes,
  LocationTypes,
  type UserServices,
  RAIL_COMPANY_TO_SUPPLIER_CODE,
  RailCompanies,
  clone
} from '@sabstravtech/obtservices/base';
import { Router } from '@angular/router';

import { LightningUserFavorurite } from '../../../core/classes/user-favourite.enum';
import { BaseComponent } from '../../../core/components/base_components/base-componet';
import { LightToggleBtnComponent } from '../../../startup/light-toggle-btn/light-toggle-btn.component';
import { DeviceDetector } from '../../../core/services/device-detector.service';
import { Helpers } from '../../../core/classes/helpers';

@Component({
  selector: 'app-rail-search',
  templateUrl: './rail-search.component.html',
  styleUrls: ['./rail-search.component.scss'],
  standalone: false
})
export class RailSearchComponent extends BaseComponent implements OnInit {
  @ViewChildren(NgbInputDatepicker) datepickerList: QueryList<NgbInputDatepicker>;
  // public moment: Date = new Date()
  @ViewChild('onewayBtn') oneWayBtn: LightToggleBtnComponent;
  @ViewChild('returnBtn') returnBtn: LightToggleBtnComponent;
  @ViewChild('instance') instance: NgbTypeahead;
  @ViewChild('ttip') ttip: NgbTooltip;
  focus$ = new Subject<string>();
  focus2$ = new Subject<string>();
  focus3$ = new Subject<string>();
  public input1Moment: any;

  showNotShow: string;
  bringToFront: string;
  isReturnSelected: false;
  openReturnTrue: false;
  results: string[];
  allowOpenReturn = true;
  hideLiveRail = false;
  hideOpenReturn = false;
  hideClasses = false;
  ShowCarnet = false;
  // serviceClasses: string[] = ['Any', 'Standard'];

  travellingFrom: Observable<any[]> = of([]);
  travellingTo: Observable<any[]> = of([]);
  viaLocation: Observable<any[]> = of([]);
  got_railcards = false;

  ServiceType: typeof ServiceType = ServiceType;
  RailJourneyType: typeof RailSearchJourneyType = RailSearchJourneyType;
  searchParams: RailEnterpriseSearchInterface;

  typeaHeadLimit = Number.MAX_SAFE_INTEGER;
  chosenRailCards: ReferenceRailCardQualifier[] = [];
  railCards: ReferenceRailCardQualifier[] = [];

  travellers: Traveller[];
  // journeyType: RailJourneyType = RailJourneyType.ReturnJourney;
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public selectedTravelCards: (ReferenceRailCardQualifier & {
    userId?: string;
    number?: string;
  })[] = [];
  trainlineEnabled = false;
  euSearchEnabled = false;
  showLoyaltyNumber = false;
  cardPattern = '';

  hotelsearchRequested = false;
  displayHotelCheck = false;
  isEvolvi = false;
  showFavourites = false;
  services: UserServices;
  @Output() toggleHotelSearchRequested: EventEmitter<boolean> = new EventEmitter();

  get hasFromError(): boolean {
    if (!this.searchService.show_errors) return false;
    return !!this.searchParams?.validationMessages?.some(
      (m) => m.includes('From Location') || m.includes('station cannot be the same')
    );
  }

  get hasToError(): boolean {
    if (!this.searchService.show_errors) return false;
    return !!this.searchParams?.validationMessages?.some(
      (m) => m.includes('To Location') || m.includes('station cannot be the same')
    );
  }

  // Inject HttpClient into rail search component or service
  constructor(
    public deviceDetector: DeviceDetector,
    public searchService: EnterpriseSearchService,
    private titleCasePipe: TitleCasePipe,
    private userService: UserService,
    title: Title,
    public translateService: TranslateService,
    private router: Router
  ) {
    super(title, translateService);
  }

  ngOnInit(): void {
    this.searchParams = this.searchService.searches[ServiceType.Rail];
    this.services = this.userService.fullUserDetails.userServices.value;
    this.subscribe(this.userService.fullUserDetails.userServices, () => {
      this.trainlineEnabled = this.userService.userHasServiceProvider(
        ServiceType.Rail,
        ServiceProvider.Trainline
      );
      console.log(`+++ User has trainline enabled: ${this.trainlineEnabled} +++`);
      this.isEvolvi = this.userService.userHasServiceProvider(
        ServiceType.Rail,
        ServiceProvider.Evolvi
      );

      this.subscribe(this.searchParams.locationChange, (change) => {
        console.log(`+++ Rail location changed: ${change} +++`);
        this.loadRailcards();
      });
      if (this.trainlineEnabled) {
        this.subscribe(
          this.searchService.getTrainlineSearchConfig(),
          (data) => {
            // console.warn(`+++ User trainline search config: ${data} ${this.searchParams.isLoading.value} +++`);
            if (data === TrainlineSearchConfigTypes.ukAndEurope) {
              this.euSearchEnabled = true;
              // console.log('+++ Setting Default Location +++');
              this.searchParams.setDefaultLocation();
              this.loadRailcards();
            } else if (data === TrainlineSearchConfigTypes.allOfEurope) {
              if (this.isEvolvi) {
                this.euSearchEnabled = true;
                if (this.searchParams.location === 'UK') {
                  this.searchParams.changeLocation('UK');
                }
              } else {
                this.euSearchEnabled = false;
                this.searchParams.changeLocation('EU');
              }
              this.loadRailcards();
            } else if (data === TrainlineSearchConfigTypes.ukOnly) {
              this.euSearchEnabled = false;
              this.searchParams.changeLocation('UK');
              this.loadRailcards();
            }
          },
          (error) => {
            console.error(`+++ Error fetching trainline search config ${error} +++`);
          }
        );
      }
    });

    // Subscribe to travellerInformation and re-apply railcard logic on change
    // but don't override a railcard explicitly set by the chatbot
    this.subscribe(this.searchService.travellerInformation, (data) => {
      console.log('travellerInformation changed: ', data);
      if (!this.searchParams.applyRailcards) {
        this.preselectRailcardsForTravellers(data);
      }
    });

    if (this.searchParams.railCards.length) {
      this.selectedTravelCards = this.searchParams.railCards.map((railCard) => {
        if (!railCard?.code) {
          return undefined;
        }
        return railCard;
      });
    }

    this.bringToFront = '-2';
    this.ShowCarnet = this.userService.isUserFavoriteSet(LightningUserFavorurite.carnet_tickets);
    this.allowOpenReturn = !this.userService.isUserFavoriteSet(
      LightningUserFavorurite.no_open_returns
    );
    this.hideLiveRail =
      this.userService.getUserFavoriteObject<{ hideLiveRail: { value: boolean } }>(
        LightningUserFavorurite.RailSearchFormConfiguration
      )?.hideLiveRail.value || false;

    this.hideOpenReturn =
      this.userService.getUserFavoriteObject<{ hideOpenReturn: { value: boolean } }>(
        LightningUserFavorurite.RailSearchFormConfiguration
      )?.hideOpenReturn?.value || false;

    const hideClasses = this.userService.getUserFavoriteObject<{
      hideRailClasses: {
        any: boolean;
        standard: boolean;
        first: boolean;
      };
    }>(LightningUserFavorurite.RailSearchFormConfiguration)?.hideRailClasses || {
      any: false,
      standard: false,
      first: false
    };

    if (hideClasses.any && hideClasses.standard && hideClasses.first) {
      this.hideClasses = true;
    }

    this.checkOutboundReturnDateTimes();
    console.log(this.searchParams);
    this.loadRailcards();
    this.subscribe(this.searchParams.classTypes, (classTypes) => {
      // If the chosen search type is not part of the allowed class types, default it to the first available option
      if (classTypes && classTypes.length) {
        const classTypesWithChosenType = classTypes.filter(
          (classType) => classType.value === this.searchParams.chosenSearchClass
        );
        if (!classTypesWithChosenType.length) {
          this.searchParams.chosenSearchClass = classTypes[0].value;
        }
      }
    });
    this.showFavouritesOption();
    this.resolveTimes();
  }

  showFavouritesOption() {
    this.searchService.isFavoritesSelected = false;
    this.showFavourites = (
      this.userService.getUserFavoriteObject(
        LightningUserFavorurite.RailSearchFormConfiguration
      ) as { enableFavoritesOptionForRails: boolean }
    )?.enableFavoritesOptionForRails;
  }

  private preselectRailcardsForTravellers(travellers?: Traveller[]) {
    // Fetch the logged-in user's rail loyalty codes
    if (!travellers || !travellers.length) {
      travellers = this.searchService.travellerInformation?.value || [];
    }
    if (!travellers.length) {
      // Don't clear a railcard the chatbot explicitly set
      if (this.searchParams.applyRailcards) {
        return;
      }
      // No travellers to process, clear selections
      this.selectedTravelCards = [];
      this.searchParams.railCards = [];
      this.searchParams.applyRailcards = false;
      return;
    }
    travellers.forEach((traveller, idx) => {
      if (traveller.guest) {
        return;
      }
      this.subscribe(this.userService.getUserDocumentLoyalty(traveller.id), (user: User) => {
        if (this.searchParams.applyRailcards) {
          return;
        }
        const railLoyaltyCodes = (user.loyaltyCodes || []).filter(
          (lc) => lc.type === ServiceType.Rail
        );

        // Helper to find a matching supplier card for a loyalty code using RAIL_COMPANY_TO_SUPPLIER_CODE
        const findSupplierCard = (
          loyaltyCode: UserLoyaltyCode
        ): (ReferenceRailCardQualifier & { number?: string }) | undefined => {
          const mapped = RailCompanies.find((rc) => rc.value === loyaltyCode.carrier);
          if (!mapped) {
            return undefined;
          }
          const supplierCode = RAIL_COMPANY_TO_SUPPLIER_CODE[mapped.label];
          if (!supplierCode) {
            return undefined;
          }
          // Match exact code (Evolvi) or URN containing the code (Trainline)
          const card = this.railCards.find(
            (c) => c.code === supplierCode || c.code?.includes(`:card:${supplierCode}___`)
          );
          if (card) {
            return { ...card, number: loyaltyCode.code };
          }
          return undefined;
        };

        // Find the first loyalty code that matches a supplier card
        let foundPreselected = false;
        for (const loyaltyCode of railLoyaltyCodes) {
          const supplierCard = findSupplierCard(loyaltyCode);
          if (supplierCard) {
            this.selectedTravelCards[idx] = { ...supplierCard, userId: traveller.id };
            foundPreselected = true;
            break;
          }
        }
        if (!foundPreselected) {
          this.selectedTravelCards[idx] = undefined;
        }

        // Optionally, update searchParams.railCards and applyRailcards
        this.searchParams.railCards = this.selectedTravelCards;
        this.searchParams.applyRailcards = this.selectedTravelCards.some((card) => !!card);
      });
    });
  }

  // @desc - load in the railcards
  loadRailcards(): void {
    this.subscribe(
      this.searchService.getRailCards(this.searchParams.ukRail ? 'GB' : 'EU'),
      (data) => {
        this.railCards = data || [];
        // Don't override a railcard the chatbot explicitly set
        if (!this.searchParams.applyRailcards) {
          this.preselectRailcardsForTravellers();
        }
        if (this.searchParams.railCards.length && data.length) {
          this.selectedTravelCards = this.searchParams.railCards.map((railCard) => {
            if (!railCard?.code) {
              return undefined;
            }
            const foundCard = data.find((card) => card.code === railCard.code);
            return foundCard;
          });
        }
      }
    );
  }

  /**
  @desc - returns NgbDateStruct object representing todays date
  **/
  getTodaysDate(): NgbDateStruct {
    const year = parseInt(moment().format('YYYY'), 10);
    const month = parseInt(moment().format('M'), 10);
    const day = parseInt(moment().format('D'), 10);
    return { year, month, day };
  }

  /**
  @desc - sets default date and times for outbound and return journeys, if not set previously by the user
  **/
  checkOutboundReturnDateTimes(): void {
    const today = this.getTodaysDate();
    // check outbound
    if (!this.searchParams.outbound_date) {
      this.searchParams.outbound_date = today;
    }
    if (!this.searchParams.outbound_time) {
      this.searchParams.outbound_time = '0700';
    }
    // check return
    if (!this.searchParams.return_date) {
      this.searchParams.return_date = today;
    }
    if (!this.searchParams.return_time) {
      this.searchParams.return_time = '1600';
    }
  }

  /**
  @desc - when the user changes the outbound date, update the return date to match the outbound date
  **/
  onOutboundDateChange(): void {
    this.searchParams.return_date = this.searchParams.outbound_date;
  }

  showApplyRailModal() {
    if (this.searchParams.applyRailcards) {
      this.ttip.open();
    } else {
      this.selectedTravelCards = [];
      this.ttip.close();
    }
  }

  @HostListener('document:click', ['$event'])
  public onClick(event) {
    Helpers.closeOpenCalendars(this.datepickerList, event);
  }

  ticketTypeOneWay(): void {
    this.showNotShow = 'rgba(0,0,0,0.9)';
    this.bringToFront = '2';
  }

  returnTimeProximity(prox): void {}

  // changeTicketType(event: RailJourneyType, secondPaam): void {
  //   console.log(event);
  //   this.searchParams.chosenSearchType = event;
  // }

  searchJourneyType(type: RailSearchJourneyType) {
    this.searchService.isFavoritesSelected = false;
    if (
      (type === RailSearchJourneyType.ReturnJourney && !this.returnBtn.disabled) ||
      type === RailSearchJourneyType.SingleJourney
    ) {
      this.searchParams.chosenSearchType = type;
    }
  }

  onCarnetTicketChange(value: boolean): void {
    if (value) {
      this.oneWayBtn.click();
      this.searchParams.chosenSearchType = RailSearchJourneyType.SingleJourney;
      this.returnBtn.disabled = true;
    } else {
      this.returnBtn.disabled = false;
    }
  }

  ticketTypeReturn(): void {
    this.showNotShow = null;
    this.bringToFront = '-2';
  }

  formatter = (x: { destination: string }): string => this.titleCasePipe.transform(x.destination);
  formatter2 = (x: { name: string }) => x.name;

  railLocations = (text$: Observable<string>): Observable<LocationDetails[]> =>
    this.locationTypeahead(text$);
  railLocations2 = (text$: Observable<string>) => this.locationTypeahead(text$);
  railLocations3 = (text$: Observable<string>) => this.locationTypeahead(text$);

  private locationTypeahead(text$: Observable<string>): Observable<LocationDetails[]> {
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((term: string): Observable<LocationDetails[]> =>
        term.length <= 2
          ? of([])
          : this.searchService
              .getStationLocations(
                term,
                this.isLoading,
                undefined,
                this.searchParams.ukRail,
                !this.searchParams.ukRail
              )
              .pipe(
                map((res: any[]) => {
                  console.log(res);
                  return res.slice(0, this.typeaHeadLimit);
                }),
                catchError(() => of([]))
              )
      )
    );
  }

  changeRailcardOption(index: number, travellerId: string): void {
    const selectedRailCard = clone(this.selectedTravelCards);
    if (!selectedRailCard[index]) {
      selectedRailCard[index] = {
        code: '',
        name: ''
      };
    }
    selectedRailCard[index].userId = travellerId;
    this.selectedTravelCards = selectedRailCard;
    this.searchParams.railCards = selectedRailCard;
  }

  ensureElementIsScrolledTo(event) {
    try {
      const typeAheadList = event.target.nextElementSibling;
      const activeButton = typeAheadList.getElementsByClassName('active')[0];
      if (
        activeButton.offsetTop + activeButton.clientHeight >
        typeAheadList.clientHeight + typeAheadList.scrollTop
      ) {
        typeAheadList.scrollTop =
          activeButton.offsetTop + activeButton.clientHeight - typeAheadList.clientHeight;
      } else if (activeButton.offsetTop < typeAheadList.scrollTop) {
        typeAheadList.scrollTop = activeButton.offsetTop;
      }
    } catch (e) {
      console.log("Couldn't find elements to scroll");
    }
  }

  isValidTime(favouriteTime: string): boolean {
    return !!favouriteTime.match(/^(\d{2}):(\d{2})$/);
  }

  roundToNearest30(time: string) {
    const m = moment(`2018-12-08 ${time}`);
    return m.minute() >= 30 ? m.minutes(30).format('HH:mm') : m.minutes(0).format('HH:mm');
  }

  goToLiveSearch() {
    // this.searchService[ServiceType.Rail].isLiveRail = true;
    this.router.navigate(['live-rail']);
  }

  cardComparator(a: ReferenceRailCardQualifier, b: ReferenceRailCardQualifier): boolean {
    return a?.name === b?.name;
  }

  trackByClass(index: number, allowedClass: AllowedRailClass): string {
    return allowedClass.value.toString();
  }

  changeLocation(newLocation: string): void {
    console.log(`+++ Location changed to: ${newLocation} +++`);
    this.searchParams.results.next([]);
    if (newLocation === 'EU') {
      this.searchParams.setupTrainlineEUTravellers();
    }
  }

  checkHotelCheckbox() {
    this.displayHotelCheck =
      this.checkDiffBetweenDates(
        this.searchParams.outBoundDateTime,
        this.searchParams.inBoundDateTime
      ) &&
      this.searchParams.chosenSearchType === this.RailJourneyType.ReturnJourney &&
      !!this.searchParams.travellingFrom &&
      !!this.searchParams.travellingTo;
    if (
      !this.displayHotelCheck &&
      this.toggleHotelSearchRequested.observed &&
      !this.searchParams.isRailHotelComboSearch
    ) {
      this.hotelsearchRequested = false;
      this.toggleHotelSearchRequested.emit(this.hotelsearchRequested);
    } else if (this.displayHotelCheck || this.searchParams.isRailHotelComboSearch) {
      this.requireHotelCheckbox(true);
    }
  }

  checkDiffBetweenDates(outBoundDate: moment.Moment, inboundDate: moment.Moment): boolean {
    return !outBoundDate.isSame(inboundDate, 'date') && inboundDate > outBoundDate; // If they're not on the same date, and inbound is later than outbound, then the stay must be atleast over 1 night
  }

  toggleHotelCheckbox() {
    this.hotelsearchRequested = !this.hotelsearchRequested;
    this.requireHotelCheckbox(this.hotelsearchRequested);
    this.toggleHotelSearchRequested.emit(this.hotelsearchRequested);
  }

  requireHotelCheckbox(isHotelRequired = false): void {
    if (!isHotelRequired) {
      return;
    }
    this.searchService.searches[ServiceType.Hotel].checkin_date =
      this.searchParams.outBoundDateTime;
    this.searchService.searches[ServiceType.Hotel].checkout_date =
      this.searchParams.inBoundDateTime;
    const { latitude, longitude, type, name, railstation } = this.searchParams.travellingTo;
    const locationDetail: LocationDetails = { latitude, longitude, type, name };
    if (railstation?.stationCode) {
      locationDetail.stationCode = railstation.stationCode;
    }
    if (railstation?.locationDetails?.countryCode) {
      locationDetail.countryCode = railstation.locationDetails.countryCode;
    }
    this.searchService.searches[ServiceType.Hotel].location = locationDetail;
    this.searchService.searches[ServiceType.Hotel].trainsStation =
      this.searchParams.travellingTo?.railstation;

    const hotelCounty = {
      cCode: this.searchParams.travellingTo?.railstation?.locationDetails?.countryCode,
      cName: this.searchParams.travellingTo?.railstation?.locationDetails?.country
    };

    this.searchService.searches[ServiceType.Hotel].country = hotelCounty;
    this.searchService.searches[ServiceType.Hotel].location_type_select = LocationTypes.Address;
  }

  handleLocationsSwapped(event: { depart: any; arrive: any }) {
    this.searchParams.travellingFrom = event.depart;
    this.searchParams.travellingTo = event.arrive;
  }
  resolveTimes(): void {
    // When using the later/earlier buttons the time can get set to a time outside the 15 minute intervals we display, ensure we set time to the closest 15 mins when displaying the form so the select isn't empty
    const outboundTime = this.searchParams.outBoundDateTime;
    const inboundTime = this.searchParams.inBoundDateTime;

    const outboundRemainder = outboundTime.minute() % 15;
    const inboundRemainder = inboundTime.minute() % 15;

    if (outboundRemainder && outboundRemainder < 8) {
      outboundTime.subtract(outboundRemainder, 'minutes');
      this.searchParams.outbound_time = outboundTime.format('HHmm');
    } else if (outboundRemainder) {
      outboundTime.add(15 - outboundRemainder, 'minutes');
      this.searchParams.outbound_time = outboundTime.format('HHmm');
    }

    if (inboundRemainder && inboundRemainder < 8) {
      inboundTime.subtract(inboundRemainder, 'minutes');
      this.searchParams.return_time = inboundTime.format('HHmm');
    } else if (inboundRemainder) {
      inboundTime.add(15 - inboundRemainder, 'minutes');
      this.searchParams.return_time = inboundTime.format('HHmm');
    }
  }
}
